module.exports = __webpack_public_path__ + "img/ic_gameresult.01c8d51a.png";